import { useState } from 'react'
import { label } from 'constants/labels'
import InputPassword from 'components/inputPassword/index'
import Button from 'components/button'
import { validateChangeForgotPasswordMail as validateForm } from './helpers/validate'
import { useParams } from 'react-router-dom'
import styles from '../../pages/auth/auth.module.scss'
import { errChangeForgotPassword as errorMsg } from './helpers/errorMsg'
import { useSelector } from 'react-redux'

const FormForgotPassword = ({ onSubmit }) => {
  const isLoading = useSelector(state => state.static.isLoading)
  const { forgotToken, email } = useParams()
  const [error, setError] = useState(false)
  const [user, setUser] = useState({
    token: forgotToken,
    email: JSON.parse(atob(email)),
    lozinka: '',
    lozinkaPotvrda: ''
  })

  const handleChange = e => {
    setError(false)
    const { name, value } = e.target
    setUser(userData => ({ ...userData, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (validateForm(user)) onSubmit(user)
    else setError(true)
  }

  return (
    <>
      <div>
        <h2>Resetuj lozinku</h2>
        <InputPassword
          className="form-control"
          name="lozinka"
          value={user.lozinka}
          label={label.passwordInput}
          onChange={handleChange}
          placeholder={label.placeholder}
          errorTxt={error && errorMsg('lozinka', user)}
          globalClass="mb-2"
        />
        <InputPassword
          className="form-control"
          name="lozinkaPotvrda"
          value={user.lozinkaPotvrda}
          label={label.passwordConfirm}
          onChange={handleChange}
          placeholder={label.placeholder}
          errorTxt={error && errorMsg('lozinkaPotvrda', user)}
          globalClass="mb-2"
        />
      </div>
      <div className={styles.btn}>
        <Button onClick={e => handleSubmit(e)} label={'Pošalji'} globalClass="mt-2 w-100" disabled={isLoading} loading={isLoading} />
      </div>
    </>
  )
}

export default FormForgotPassword
